// extracted by mini-css-extract-plugin
export default {"wrapper":"grantUser_wrapper__UtRJh"};